// extracted by mini-css-extract-plugin
module.exports = {"container":"_7q3gyWwLDcAvshsvfiAMH","bankSettingsWrapper":"_1f6XDLSGek4wy-YEVKNfgI"};